{
	"actions": {
		"cancel": "Annulla",
		"change": "Modifica",
		"confirm": "Salva la modifica",
		"saving": "Salvataggio…",
		"use_default": "Usa il default dell'istanza"
	},
	"field": {
		"in_force": "In vigore",
		"instance_default_inline": "Default dell'istanza: {{value}}"
	},
	"internal_link": {
		"choice": {
			"editor": "Può modificare",
			"editor_help": "Chiunque nell'organizzazione con il link può vedere o modificare.",
			"off": "Disattivati",
			"off_help": "Nessuno può aprire un file o una cartella all'organizzazione. Quelli già aperti non danno più accesso; le persone aggiunte lo mantengono.",
			"viewer": "Può vedere",
			"viewer_help": "Chiunque nell'organizzazione con il link può al massimo vedere."
		},
		"description": "Se un file o una cartella può essere aperto a chiunque nell'organizzazione con il suo link, e con quale ruolo al massimo.",
		"saved": "La regola dei link dentro l'organizzazione è stata cambiata.",
		"title": "Link dentro l'organizzazione"
	},
	"offline": {
		"description": "Le regole non si possono leggere mentre il browser è offline. Non è cambiato niente: la pagina si riempie appena torna la connessione.",
		"title": "Nessuna connessione"
	},
	"page_title": "Regole",
	"public_links": {
		"allow": {
			"detail": "Chi apre un link vede e scarica solo ciò che il link espone.",
			"detail_off": "Nessuno può creare link nuovi. Quelli esistenti sono sospesi, non cancellati.",
			"saved_off": "I link pubblici sono disattivati.",
			"saved_on": "I link pubblici sono consentiti.",
			"title": "Consenti i link pubblici"
		},
		"default_expiry": {
			"detail": "Quella che riceve un nuovo link se chi lo crea non ne sceglie una.",
			"saved": "La scadenza predefinita dei link è stata cambiata.",
			"title": "Scadenza predefinita"
		},
		"description": "Un link pubblico apre un file o una cartella a chiunque lo riceva, anche senza account.",
		"disable_dialog": {
			"cancel": "Annulla",
			"confirm": "Disattiva",
			"consequence": {
				"description": "I link già creati smettono di funzionare e restano in «Link attivi», segnati «Bloccato da policy». Se riattivi questa regola tornano a funzionare da soli.",
				"title": "Nessun link viene cancellato"
			},
			"description": "Nessuno nell'organizzazione potrà più creare link pubblici.",
			"title": "Disattivare i link pubblici?"
		},
		"max_expiry": {
			"days_one": "{{count, number}} giorno",
			"days_other": "{{count, number}} giorni",
			"detail": "Il limite per i nuovi link. Non accorcia quelli già creati.",
			"saved": "La scadenza massima dei link è stata cambiata.",
			"title": "Durata massima"
		},
		"needs_expiry": "Disponibile quando la scadenza è obbligatoria.",
		"require_expiry": {
			"detail_off": "Chi crea un link può scegliere di non farlo scadere.",
			"detail_on": "Ogni nuovo link deve scadere entro la durata massima.",
			"saved_off": "La scadenza non è più obbligatoria sui nuovi link.",
			"saved_on": "Ogni nuovo link dovrà avere una scadenza.",
			"title": "Richiedi sempre una scadenza"
		},
		"require_password": {
			"detail": "Vale per i nuovi link. Quelli già attivi restano come sono.",
			"saved_off": "La password non è più richiesta sui nuovi link.",
			"saved_on": "Ogni nuovo link dovrà avere una password.",
			"title": "Richiedi sempre una password"
		},
		"title": "Link pubblici"
	},
	"refusal": {
		"insufficient_role": "Questa regola non è tua da cambiare. Le impostazioni valide per tutta l'istanza appartengono a chi la gestisce.",
		"unknown_key": "Questa istanza non valuta quella regola, quindi non è stato salvato niente. Ricarica la pagina e riprova.",
		"value_above_ceiling": "Questa istanza consente al massimo {{max}}. Abbassa il valore e riprova: non è stato cambiato niente.",
		"value_below_floor": "Questa istanza conserva almeno {{min}}. Alza il valore e riprova: non è stato cambiato niente.",
		"value_out_of_bounds": "Questa istanza accetta un valore fra {{min}} e {{max}}. Non è stato cambiato niente.",
		"value_rejected": "Questa istanza non accetta quel valore. Non è stato cambiato niente."
	},
	"retention": {
		"bounds": "Questa istanza accetta fra {{min}} e {{max}} giorni.",
		"card_description": "Per quanto tempo gli eventi di audit restano prima che una spazzata pianificata li rimuova. È lo stesso numero che la pagina dell'audit mostra come «conservati per N giorni».",
		"card_title": "Conservazione dell'audit",
		"confirm_removal": "Riduci e rimuovi",
		"consequence": {
			"counting": "Sto contando cosa verrebbe rimosso…",
			"lengthening": "Non viene rimosso niente, e la finestra più lunga vale da adesso in avanti. Gli eventi già rimossi da una spazzata precedente non tornano.",
			"lengthening_title": "Non viene rimosso niente",
			"none": "Nessun evento risulta registrato prima del {{date}}, quindi oggi non verrebbe rimosso niente. La finestra resta comunque più corta da adesso in avanti: gli eventi inizieranno a essere rimossi prima del previsto.",
			"removal_one": "{{count, number}} evento registrato prima del {{date}} verrà rimosso per sempre alla prossima spazzata di conservazione. Non esiste un export da cui recuperarlo, e niente in questo prodotto può ripristinarlo.",
			"removal_other": "{{count, number}} eventi registrati prima del {{date}} verranno rimossi per sempre alla prossima spazzata di conservazione. Non esiste un export da cui recuperarli, e niente in questo prodotto può ripristinarli.",
			"removal_title": "Questa modifica rimuove eventi, per sempre",
			"uncounted": "Gli eventi registrati prima del {{date}} verranno rimossi per sempre alla prossima spazzata, e non si possono ripristinare. Il conteggio non è disponibile adesso, quindi non è possibile dire quanti sono."
		},
		"days_one": "{{count, number}} giorno",
		"days_other": "{{count, number}} giorni",
		"description": "Gli eventi più vecchi di questa finestra vengono rimossi da una spazzata pianificata. Ridurla rimuove ciò che già oggi cade fuori dalla nuova finestra.",
		"field_label": "Giorni conservati",
		"row_bounds": "Fra {{min}} e {{max}} giorni",
		"saved": "La finestra di conservazione è stata cambiata.",
		"title": "Cambia la conservazione dell'audit"
	},
	"unavailable": {
		"description": "Non è stato possibile leggere le regole. Restano quelle che erano: è un problema di lettura, non delle regole. Riprova fra un momento.",
		"title": "Non è stato possibile leggere le regole"
	},
	"unrecognized": {
		"description": "Una regola che questa istanza valuta e per cui questa schermata non ha ancora un controllo. È mostrata perché tu sappia che è in vigore."
	},
	"who_can_share": {
		"choice": {
			"everyone": "Editor",
			"everyone_help": "Chi può modificare un file o una cartella può anche condividerlo.",
			"owner_only": "Solo il proprietario",
			"owner_only_help": "Solo chi possiede un file o una cartella può condividerlo."
		},
		"description": "Il permesso minimo per condividere un file o una cartella con un collega.",
		"saved": "La regola di condivisione è stata cambiata.",
		"title": "Chi può condividere"
	}
}
